import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MapPin, ArrowUpRight, Calendar as CalIcon } from "lucide-react";

const formatBannerDate = (iso) => {
  const d = new Date(iso + "T00:00:00");
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const dayShort = d.toLocaleDateString("en-US", { weekday: "short" }).toUpperCase();
  const monthDay = d.toLocaleDateString("en-US", { month: "short", day: "numeric" }).toUpperCase();

  if (d.getTime() === today.getTime()) return `TONIGHT · ${monthDay}`;
  if (d.getTime() === tomorrow.getTime()) return `TOMORROW · ${monthDay}`;
  return `${dayShort} · ${monthDay}`;
};

const NextShowBanner = () => {
  const [gig, setGig] = useState(null);

  useEffect(() => {
    api.get("/gigs").then((r) => {
      const today = new Date().toISOString().split("T")[0];
      const upcoming = (r.data || [])
        .filter((g) => g.date >= today)
        .sort((a, b) => (a.date === b.date ? a.time.localeCompare(b.time) : a.date.localeCompare(b.date)));
      if (upcoming.length > 0) setGig(upcoming[0]);
    }).catch(() => {});
  }, []);

  if (!gig) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] bg-yellow-300 text-black border-b-2 border-black"
      data-testid="next-show-banner"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-10 h-10 flex items-center justify-between gap-3">
        <Link
          to="/gigs"
          className="flex items-center gap-3 min-w-0 hover:opacity-80 transition-opacity"
          data-testid="next-show-link"
        >
          <span className="font-mono text-[10px] tracking-[0.25em] uppercase hidden sm:inline-block bg-black text-yellow-300 px-2 py-0.5">
            Next show
          </span>
          <span className="font-mono text-[11px] md:text-xs tracking-[0.15em] uppercase font-bold shrink-0">
            {formatBannerDate(gig.date)}
          </span>
          <span className="font-mono text-[11px] md:text-xs uppercase tracking-[0.1em] truncate font-semibold" data-testid="next-show-venue">
            · {gig.venue_name}
          </span>
          <span className="font-mono text-[11px] md:text-xs uppercase tracking-[0.1em] text-neutral-800 hidden md:inline">
            · {gig.time}
          </span>
        </Link>
        <div className="flex items-center gap-2 shrink-0">
          {gig.map_url && (
            <a
              href={gig.map_url}
              target="_blank"
              rel="noreferrer"
              className="font-mono text-[10px] md:text-xs tracking-[0.2em] uppercase font-bold flex items-center gap-1 border-2 border-black px-2 md:px-3 py-0.5 hover:bg-black hover:text-yellow-300 transition-colors"
              data-testid="next-show-directions"
            >
              <MapPin size={11} />
              <span className="hidden sm:inline">Directions</span>
              <ArrowUpRight size={10} />
            </a>
          )}
          <Link
            to="/gigs"
            className="font-mono text-[10px] md:text-xs tracking-[0.2em] uppercase font-bold items-center gap-1 hidden md:inline-flex hover:opacity-70"
            data-testid="next-show-all"
          >
            <CalIcon size={11} /> All Gigs
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NextShowBanner;
